import { useCallback } from 'react';
import { useArticleContext } from './useArticleContext';
import { gql } from '@apollo/client';
import {
  graphql,
  useAnalytics,
  METRICS_ARTICLES_SAVED_COUNT,
} from '@xolv-mybrightlink/common';

const ADD_ARTICLE_BOOKMARK = gql`
  mutation addBookmarkItem($slug: String) {
    bookmarkItem(bookmark: { slug: $slug, type: "article" })
  }
`;

const bookmarkArticle = async (slug: string) => {
  await graphql.mutate({
    mutation: ADD_ARTICLE_BOOKMARK,
    variables: { slug },
  });
};

const REMOVE_ARTICLE_BOOKMARK = gql`
  mutation removeBookmarkedItem($slug: String) {
    removeBookmarkedItem(bookmark: { slug: $slug, type: "article" })
  }
`;

export const removeBookmarkArticle = async (slug: string) => {
  await graphql.mutate({
    mutation: REMOVE_ARTICLE_BOOKMARK,
    variables: { slug },
  });
};

export const useBookmarkArticle = () => {
  const [state, dispatch] = useArticleContext();
  const analytics = useAnalytics();
  return useCallback(
    async (databaseId: number, categoryId: string) => {
      if (state.initial) {
        return;
      }
      let article = state.data[categoryId]?.articles.find(
        (article) => article.databaseId === databaseId,
      );
      if (!article) {
        const articleDetail = state.articleDetails.find(
          (item) => item.databaseId === databaseId,
        );
        const articleDetailData = articleDetail?.data;
        if (articleDetailData && typeof articleDetailData !== 'string') {
          article = articleDetailData;
        }
      }
      if (article) {
        if (article.isSaved) {
          await removeBookmarkArticle(article.slug);
          analytics.incrementUserProperty(METRICS_ARTICLES_SAVED_COUNT, -1);
        } else {
          await bookmarkArticle(article?.slug);
          analytics.incrementUserProperty(METRICS_ARTICLES_SAVED_COUNT, 1);
        }
        dispatch({
          type: 'bookmark',
          databaseId,
        });
      }
    },
    [dispatch, state, analytics],
  );
};
